module.exports = __webpack_public_path__ + "img/icon_youhui.83820135.svg";